import React, {useState, useEffect} from 'react';
import useAuth from '../../../hooks/useAuth';
import { bookingService } from '../../../services/bookingService';


const MyBooking = () => {
    const [booking, setBooking] = useState([]);
    const {user} = useAuth({});

    useEffect(() => {
        if(user?.email) {
            bookingService.getMyBookings(user.email)
            .then(result => setBooking(result))
            .catch(err => console.error(err));
        }
    }, [user.email]);

    const handleDelete = id=>{
        const confirm = window.confirm('Are you sure to delete booking?');
        if(confirm){
            bookingService.deleteBooking(id)
            .then(data=>{
                const remaining =booking.filter(book=>book._id!== id);
                setBooking(remaining);
            })
            .catch(err => console.error(err));
        }
    }

    return (
        <div className="py-24 bg-slate-50 min-h-screen mt-16">
            <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-10">
                <div className="text-center mb-16">
                    <h4 className="text-4xl md:text-5xl font-black text-slate-900 tracking-tight lowercase">my <span className="text-amber-500">bookings</span></h4>
                    <div className="w-24 h-2 bg-amber-500 mx-auto mt-6 rounded-full shadow-lg shadow-amber-500/20"></div>
                </div>
                
                <div className="bg-white shadow-2xl rounded-[2rem] overflow-hidden border border-slate-100">
                    <div className="overflow-x-auto scrollbar-hide">
                        <table className="min-w-full divide-y divide-slate-100">
                            <thead className="bg-slate-900">
                                <tr>
                                    <th scope="col" className="px-8 py-6 text-left text-xs font-black text-amber-500 uppercase tracking-[0.2em]">Name</th>
                                    <th scope="col" className="px-8 py-6 text-left text-xs font-black text-amber-500 uppercase tracking-[0.2em]">Tour Title</th>
                                    <th scope="col" className="px-8 py-6 text-left text-xs font-black text-amber-500 uppercase tracking-[0.2em]">Email</th>
                                    <th scope="col" className="px-8 py-6 text-center text-xs font-black text-amber-500 uppercase tracking-[0.2em]">Status</th>
                                    <th scope="col" className="px-8 py-6 text-center text-xs font-black text-amber-500 uppercase tracking-[0.2em]">Action</th>
                                </tr>
                            </thead>
                            <tbody className="bg-white divide-y divide-slate-100">
                                {booking.length === 0 ? (
                                    <tr>
                                        <td colSpan="5" className="px-8 py-20 text-center text-slate-400 font-medium italic">No bookings found yet. Time for an adventure?</td>
                                    </tr>
                                ) : (
                                    booking.map(book =>
                                        <tr key={book._id} className="hover:bg-slate-50 transition-colors group">
                                            <td className="px-8 py-6 whitespace-nowrap text-sm font-bold text-slate-900">{book.name}</td>
                                            <td className="px-8 py-6 text-sm text-slate-600 font-medium">{book.title}</td>
                                            <td className="px-8 py-6 whitespace-nowrap text-sm text-slate-500 font-medium">{book.email}</td>
                                            <td className="px-8 py-6 whitespace-nowrap text-center">
                                                {book?.status === "Pending" ? 
                                                    <span className="px-4 py-1.5 inline-flex text-xs leading-5 font-black rounded-full bg-amber-100 text-amber-700 uppercase tracking-widest border border-amber-200">Pending</span>
                                                    :
                                                    <span className="px-4 py-1.5 inline-flex text-xs leading-5 font-black rounded-full bg-green-100 text-green-700 uppercase tracking-widest border border-green-200">Approved</span>
                                                }
                                            </td>
                                            <td className="px-8 py-6 whitespace-nowrap text-center text-sm font-medium">
                                                <button onClick={() => handleDelete(book?._id)} className="text-slate-300 hover:text-red-500 transition-all p-3 rounded-2xl hover:bg-red-50 focus:outline-none flex items-center justify-center mx-auto border border-transparent hover:border-red-100">
                                                    <i className="far fa-trash-alt text-xl"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    )
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MyBooking;